// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pill-info-attach[data-v-a250d19e] {\n  font-size: 12px;\n}[dir] .pill-info-attach[data-v-a250d19e] {\n  border: 1px solid #3ca2d6;\n  padding: 1px 5px;\n  border-radius: 10px;\n  cursor:pointer;\n}[dir=ltr] .pill-info-attach[data-v-a250d19e] {\n  margin-right: 5px;\n}[dir=rtl] .pill-info-attach[data-v-a250d19e] {\n  margin-left: 5px;\n}\n.box-participants[data-v-a250d19e] {\n  height: 300px;\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
